import React from "react"
import {AllActivityTypesArray, TRAVEL_OPTION_TYPE} from "../../types-enums/activity";
import {getCo2KgEForAllTravelOptionTypes} from "../../utils/getter/co2-getter";
import {useTranslation} from "react-i18next";
import {Text} from "atmosfair-ui"
import {roundRelativeNumber} from "../../utils/math/round-values";
import {formatCo2ETotalString} from "../../utils/string/common";

interface EmissionsPerTravelOptionTooltipProps {
    activities: AllActivityTypesArray
    totalEmissions?: number
}

const EmissionsPerTravelOptionTooltip = ({
                                             activities,
                                             totalEmissions
                                         }: EmissionsPerTravelOptionTooltipProps) => {
    const {t, i18n} = useTranslation()
    const {resolvedLanguage} = i18n
    const co2KgEPerActivity = getCo2KgEForAllTravelOptionTypes(activities, true)

    const _renderText = (text: string, key: number) => <Text
        color={"white"}
        key={key}
        variant={"subtitleLarge"}>{text}
    </Text>

    return <div>
        {Object.entries(co2KgEPerActivity).map(([key, value], index) => {
            let emissionTypeString: string | null = null
            let co2KgE: number | null = null
            if (Object.values(TRAVEL_OPTION_TYPE).includes(key as TRAVEL_OPTION_TYPE)) {
                emissionTypeString = t(`GENERAL.${key.toUpperCase()}`);
                co2KgE = value as number
            }
            if (co2KgE !== null && emissionTypeString !== null) {
                const formattedEmissions = formatCo2ETotalString(co2KgE, resolvedLanguage)
                if (typeof totalEmissions !== "undefined") {
                    const relativeShare = ((co2KgE / totalEmissions) * 100)
                    return _renderText(`${emissionTypeString}: ${formattedEmissions} (${roundRelativeNumber(relativeShare)}%)`, index)
                }
                return _renderText(`${emissionTypeString}: ${formattedEmissions}`, index)
            }
            return null
        })
        }
    </div>
}

export default EmissionsPerTravelOptionTooltip